import { SettingsBackupRestore } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import {
  useSelection,
  useUpdateSelectionMutation,
  useDefaultSelection,
} from "hooks/selectionHooks";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { LayerProperties, Selection } from "types";

interface Props {
  config: string;
  layerProperties: LayerProperties[];
}

export function RemoveSelectionButton(props: Props) {
  return (
    <ErrorBoundary fallbackRender={() => null}>
      <Suspense fallback={null}>
        <LoadData {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}

function LoadData(props: Props) {
  const { config, layerProperties } = props;
  const { t } = useTranslation();

  const { data: selection } = useSelection(config, layerProperties);
  const { data: defaultSelection } = useDefaultSelection(config);
  const updateSelectionMutation = useUpdateSelectionMutation(
    config,
    layerProperties
  );

  async function handleClick(selection: Selection) {
    await updateSelectionMutation.mutateAsync(selection);
  }

  return render();

  function render() {
    if (!selection) return null;
    if (!defaultSelection) return null;
    if (selection.indicators.length < 1) return null;

    return (
      <Tooltip title={t("label.resetSelection").toString()} placement="right">
        <IconButton
          size="small"
          onClick={() =>
            handleClick({
              indicators: defaultSelection.selections || [],
              properties: [],
            })
          }
        >
          <SettingsBackupRestore fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }
}
